import styled from 'styled-components';
import { Box } from '@bechtel/gds';

export const RoleEditItemContainerStyled = styled(Box).attrs({
  pl: { sm: '700' },
  pr: { sm: '400' },
  py: { sm: '400' },
  mt: { sm: '500' },
  flexDirection: { sm: 'column' },
})`
  height: 210px;
  position: relative;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: ${({ theme }) => theme.radii[200]};
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 1px 10px 0 rgba(0, 0, 0, 0.12), 0 4px 5px 0 rgba(0, 0, 0, 0.14);
`;

export const EditBarStyled = styled.div`
  position: absolute;
  width: 10px;
  background-color: ${({ theme }) => theme.colors.bechtel.blue[300]};
  top: 0;
  bottom: 0;
  left: -2px;
  border-radius: ${({ theme }) => theme.radii[200]};
`;
